import { Box, Stack } from "@mui/material";

import AssistantPrimaryActions from "./AssistantPrimaryActions";
import { ChatMessageWithParts } from "src/views/assistant/types";
import MessageToggle from "./MessageToggle";
import { useChatContext } from "../context/ChatContext";
import { useLocation } from "react-router-dom";
import useMessageGroups from "../hooks/useMessageGroups";

type AssistantMessageActionsProps = {
  chatMessage: ChatMessageWithParts;
  dialogue: ChatMessageWithParts[];
  currentIndex: number;
  sortedMessageGroup: ChatMessageWithParts[];
  isChatConnected: boolean;
  isChatMessageStreamStopped: boolean;
  regenerateResponse: (index: string) => void;
  handlePrev: () => void;
  handleNext: () => void;
};

const AssistantMessageActions = ({
  chatMessage,
  dialogue,
  currentIndex,
  sortedMessageGroup,
  isChatConnected,
  isChatMessageStreamStopped,
  regenerateResponse,
  handlePrev,
  handleNext,
}: AssistantMessageActionsProps) => {
  const { MoreAssistantActions, MoreAssistantActionsProps } = useChatContext();

  const { isPreferredMessagePicked, isFeedbackTypeDpo } =
    useMessageGroups(sortedMessageGroup);

  // get query params from the is_OCbot with react router dom
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const is_OCBot = searchParams.get("is_OCBot");

  return (
    <Box>
      <Stack direction="row" gap={1.5} alignItems="center">
        {isPreferredMessagePicked && isFeedbackTypeDpo && (
          <Box sx={{ paddingY: 0.3 }}>
            <MessageToggle
              sortedMessageGroup={sortedMessageGroup}
              currentIndex={currentIndex}
              handlePrev={handlePrev}
              handleNext={handleNext}
            />
          </Box>
        )}
        {(!is_OCBot || dialogue?.length > 1) && (
          <AssistantPrimaryActions
            chatMessage={chatMessage}
            dialogue={dialogue}
            isChatConnected={isChatConnected}
            isChatMessageStreamStopped={isChatMessageStreamStopped}
            regenerateResponse={regenerateResponse}
          />
        )}

        {/* The more message actions will go here so users can pass in their own component */}
        {MoreAssistantActions && (
          <MoreAssistantActions
            key={chatMessage.id}
            messageIndex={currentIndex}
            messageId={chatMessage.id}
            isChatConnected={isChatConnected}
            {...MoreAssistantActionsProps}
          />
        )}
      </Stack>
    </Box>
  );
};

export default AssistantMessageActions;
